<template>
  <div class="course_list_wrapper">
    <div class="course_list flex FlexWrap FlexBetween" v-if="hotCourseList.length">
      <div class="flex course_one flexcolumn FlexBetween" v-for="(item, index) in hotCourseList" :key="index"
        @mouseenter="showMoreInfo(item)" @mouseleave="hideMoreInfo(item)"
        :class="[selectedCourseId == item.courseId ? 'hover_box' : '']">
        <div class="cursor_pointer flex flexcolumn FlexBetween" @click="goCourseDetail(item)">
          <div class="course_one_top">
            <el-image class="course_one_img" style="border-radius: 20px" :src="imgPath(item.courseCoverImg)">
              <template #error>
                <div class="image-placeholder">
                  <el-icon :size="30">
                    <Picture />
                  </el-icon>
                </div>
              </template>
            </el-image>
          </div>
          <div class="course_one_title toverflows toverflow2" :class="[item.showCourseMoreInfo ? 'active_color' : '']">
            {{ item.courseName }}
          </div>
          <div class="course_one_institution flex FlexBetween">
            <div class="course_one_institution_left flex Flexalign">
              <el-avatar :size="24" :src="imgPath(item.shopLogo)" />
              <div class="institutionName toverflow">{{ item.shopName }}</div>
            </div>
            <div class="course_num">{{ item.chapterCountResult?.chapterNum }}课时</div>
          </div>
          <div class="course_rate">
            <el-rate v-model="item.rate" disabled show-score text-color="#666666" score-template="{value}分" />
          </div>
          <div class="flex FlexBetween Flexalign course_info">
            <div class="course_online">{{ item.courseExtra.userNum }}人学习</div>
            <div class="course_price" v-if="item.saleMethod == 2">
              <span class="course_price_unit">￥</span>{{ item.saleMethod == 2 ? item.coursePrice : 0 }}
            </div>
            <div class="course_price course_free" v-else>免费</div>
          </div>
        </div>
        <div class="course_more_info" v-if="item.showCourseMoreInfo">
          <div class="more_info_box">
            <div class="more_info_name">
              {{ item.courseName }}
            </div>
            <div class="flex Flexalign mar_top_10">
              <el-avatar :size="46" :src="imgPath(item.shopLogo)" />
              <div class="shop_info mar_left_10 flex-1">
                <div class="flex shop_name Flexalign">
                  <div class="toverflows toverflow2 flex-1">{{ item.shopName }}</div>
                  <el-image class="member_logo mar_left_5" :src="imgPath('institution.png')"></el-image>
                </div>
                <div class="shop_introduce mar_top_5" v-if="item.shopBrief">
                  {{ item.shopBrief }}
                </div>
              </div>
            </div>
            <div class="more_info_name more_info_name1 mar_top_15">你将学到：</div>
            <div class="learn_intro toverflows toverflow5">{{ item.courseLearnIntro }}</div>
            <div class="flex FlexBetween mar_top_15">
              <div class="btn_add cursor_pointer" @click="addCar(item.courseId, item)">
                加入购物车
              </div>
              <div class="btn_add btn_view cursor_pointer" @click="goCourseDetail(item)">
                课程详情
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="hotCourseList.length % 4 != 0" class="flex">
        <div class="empty_course_one course_one" v-for="item in 4 - (hotCourseList.length % 4)" :key="item">
          <div class="course_one_top">
            <el-image class="course_one_img" style="border-radius: 20px" :src="imgPath('course_img.png')"></el-image>
            <div class="course_one_type">热销</div>
          </div>
        </div>
      </div>
      <div class="pagination_box mar_top_20 flex FlexjustifyEnd"
        v-if="showPagination && listTotal > listQuery.pageSize">
        <el-pagination background layout="sizes, prev, pager, next" :page-sizes="[8, 16, 24, 32]" :total="listTotal"
          v-model:page-size="listQuery.pageSize" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </div>
    </div>

    <!-- 缺省效果 - 空状态 -->
    <div v-else class="empty-state">
      <el-image class="empty-image" :src="iconPath('empty_course.png')">
        <template #error>
          <div class="empty-icon">
            <el-icon :size="80">
              <FolderOpened />
            </el-icon>
          </div>
        </template>
      </el-image>
      <div class="empty-text">暂无课程</div>
      <div class="empty-tip">稍后再来看看吧~</div>
    </div>
  </div>
</template>

<script>
import { Picture, FolderOpened } from '@element-plus/icons-vue';

export default {
  name: "GjkcH5CourseList",
  components: {
    Picture,
    FolderOpened
  },
  props: {
    selectedInfo: {},
    showPagination: {
      default: true,
    },
  },
  watch: {
    selectedInfo: {
      handler(value) {
        if (!value) return;
        setTimeout(() => {
          this.listQuery = value;
          this.getCourseList();
        }, 500);
      },
      immediate: true,
      deep: true,
    },
  },

  data() {
    return {
      hotCourseList: [],
      listTotal: 0,
      listQuery: {},
      selectedCourseId: "",
    };
  },

  mounted() {
    // this.getCourseList();
  },

  methods: {
    handleSizeChange() {
      this.getCourseList();
    },
    handleCurrentChange(value) {
      this.listQuery.page = value;
      this.getCourseList();
    },
    getCourseList() {
      this.$Api.course
        .getCourseList(this.listQuery)
        .then((res) => {
          this.hotCourseList = res.data.data.list || [];
          this.hotCourseList.forEach((item) => {
            item.showCourseMoreInfo = false;
            item.rate = this.$Tools.scoreToStar(item.courseExtra?.appraiseScore || 0);
          });
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
        })
        .catch(() => {
          this.hotCourseList = [];
        });
    },
    showMoreInfo(info) {
      this.selectedCourseId = info.courseId;
      info.showCourseMoreInfo = true;
    },
    hideMoreInfo(info) {
      this.selectedCourseId = "";
      info.showCourseMoreInfo = false;
    },
    goCourseDetail(info) {
      this.$Jump.href("/courseDetail", { courseId: info.courseId });
    },
    addCar(courseId,info) {
      let params = {
        courseId: courseId, type: 1
      };
      // 判断是否是多规格
      if(info.styleSettingMode == 2){
        params.spec = JSON.stringify(JSON.parse(info.specConfig).skuList[0].spec);
      }
      this.$Api.shop
        .addCar(params)
        .then((res) => {
          console.log(res);
          this.$Dialog.toast("加入购物车成功");
          this.getCarList();
        })
        .catch((err) => {
          if (err.data.code == 910101) {
            this.$Dialog.confirm({
              message: "该课程暂未付款，是否前往订单中心，解锁该课程~",
              title: "提示",
              onConfirm: () => {
                this.href("/orderList");
              },
              onCancel: () => { },
            });
          }
        });
    },
    getCarList() {
      this.$Api.shop
        .getCarList({ type: 1 })
        .then((res) => {
          this.$store.commit("user/setMyCarList", res.data.data);
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.course_list_wrapper {
  width: 100%;
}

.course_list {
  width: $pageMainWidth;
  margin: 0 auto;

  .course_one {
    border-radius: 20px;
    padding: 11px;
    box-sizing: border-box;
    height: 320px;
    margin-top: 20px;
    position: relative;
    background: #fff;

    .course_one_top {
      position: relative;

      .course_one_img {
        width: 265px;
        height: 148px;
        border-radius: 10px;
      }

      .course_one_type {
        position: absolute;
        right: 0;
        top: 0;
        width: 54px;
        height: 21px;
        background: linear-gradient(90deg, #ff8a4c, #fe5e3c);
        border-radius: 0px 20px 0px 20px;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
      }
    }

    .course_one_title {
      width: 265px;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      margin: 5px 0;
      height: 50px;
      line-height: 25px;
    }

    .active_color {
      color: #13d6aa;
    }

    .course_one_institution {
      .course_one_institution_left {
        .institutionName {
          color: #333333;
          margin-left: 6px;
          max-width: 150px;
        }
      }

      .course_num {
        color: #666666;
      }
    }

    .course_rate {
      :deep(.el-rate .el-rate__icon) {
        margin-right: 0;
      }

      :deep(.el-rate) {
        height: auto;
      }
    }

    .course_info {
      .course_online {
        font-size: 14px;
        color: #999999;
      }

      .course_price {
        color: #ff6619;
        font-size: 22px;
        font-weight: 600;

        .course_price_unit {
          font-size: 16px;
          font-weight: 400;
        }
      }

      .course_free {
        font-size: 16px;
        font-weight: 400;
      }
    }

    .course_more_info {
      position: absolute;
      top: -30px;
      right: -270px;
      width: 270px;
      background: #ffffff;
      box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      border: 1px solid #e5e5e5;
      z-index: 9;
      box-sizing: border-box;
      padding: 15px 10px;

      .more_info_box {
        position: relative;
      }

      .more_info_box::before {
        position: absolute;
        top: 100px;
        left: -28px;
        content: "";
        border-width: 10px;
        border-style: solid;
        border-top-color: transparent;
        border-left-color: transparent;
        border-bottom-color: transparent;
        border-right-color: #fff;
      }

      .more_info_name {
        color: #303030;
        line-height: 24px;
        font-weight: 600;
        display: -webkit-box;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .more_info_name1 {
        color: #909090;
      }

      .learn_intro {
        line-height: 24px;
        color: #909090;
      }

      .shop_info {
        .shop_name {
          color: #606060;

          .member_logo {
            width: 60px;
            height: 16px;
          }
        }

        .shop_introduce {
          display: -webkit-box;
          text-overflow: ellipsis;
          overflow: hidden;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          color: #999999;
        }
      }

      .btn_add {
        width: 111px;
        height: 38px;
        border-radius: 19px;
        border: 1px solid #fe603d;
        line-height: 38px;
        text-align: center;
        color: #fe613d;
      }

      .btn_view {
        background: linear-gradient(90deg, #ff8a4c, #fe5e3c);
        border: none;
        color: #ffffff;
      }
    }
  }

  @keyframes moveUp {
    from {
      transform: translateY(0);
    }

    to {
      transform: translateY(-2px);
    }
  }

  .hover_box {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    animation: moveUp 0.5s forwards;
    z-index: 9;
  }

  .empty_course_one {
    opacity: 0;
  }

  .pagination_box {
    width: 100%;
  }
}

// 缺省效果样式
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: #fff;
  border-radius: 20px;
  text-align: center;

  .empty-image {
    width: 200px;
    height: 200px;
  }

  .empty-icon {
    color: #e0e0e0;
  }

  .empty-text {
    margin-top: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #999;
  }

  .empty-tip {
    margin-top: 8px;
    font-size: 14px;
    color: #bbb;
  }
}
</style>